import { Table, TableCell } from "@SeemplicityDev/shared";
import { type CellContext, createColumnHelper } from "@tanstack/react-table";

const viewTypeEnum = {
  scope: "Scope",
  filter: "Filter",
  group: "Scope Group",
} as const;

type ViewType = keyof typeof viewTypeEnum;

interface QueueRow {
  name: string;
}

interface FilterInQueuePopupProps {
  queuesList?: QueueRow[];
  type: ViewType;
}

const FilterInQueuePopup: React.FC<FilterInQueuePopupProps> = ({
  queuesList,
  type,
}) => {
  const columnHelper = createColumnHelper<QueueRow>();

  const columns = [
    columnHelper.accessor("name", {
      id: "name",
      cell: (props: CellContext<QueueRow, string>) => (
        <TableCell>{props.getValue()}</TableCell>
      ),
      enableSorting: false,
      enableColumnFilter: false,
      header: "Queue Name",
    }),
  ];
  return (
    <div className={"modal-text"}>
      <div className={"margin-bottom-20"}>
        {`Saving this ${viewTypeEnum[type]} will effect Findings in the following `}
        <span className={"modal-live-text"}>
          {queuesList?.length === 1 ? "" : queuesList?.length} Remediation{" "}
          {queuesList?.length === 1 ? "Queue" : "Queues"}:
        </span>
      </div>

      <div className={"queues-list-table"}>
        <Table
          rowHeight={34}
          columns={columns}
          data={queuesList}
          initialSortBy={[{ id: "name" }]}
        />
      </div>
    </div>
  );
};

export default FilterInQueuePopup;
